export default __webpack_public_path__ + "static/media/googlePlay-fr.edb58aec.svg";